type IMessageState = {
    isVisible: boolean,
    messageCategory: number,
    title: string,
    subTitle: string,
    successBar: { title: string, text: string } | null
  }

const initialState: IMessageState = {
    isVisible: false,
    messageCategory: null!,
    title: null!,
    subTitle: null!,
    successBar: null
}

export default initialState
